import {useLocalization} from 'localization';
import type {
  LinkedRoleCodeList,
  LinkedRoleCodeListId,
} from 'schemaDefinition/types/linkTypes';
import {entityLinkTypes} from '../entityLinks';
import {getLinkedSourceRoleCodelist} from '../functions/getSourceLinkedRoleCodelist';

export const useLinkedRoleCodelist = (
  codelistId: LinkedRoleCodeListId,
): LinkedRoleCodeList => {
  const localization = useLocalization();
  return getLinkedSourceRoleCodelist(codelistId, entityLinkTypes, localization);
};
